import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import "primeicons/primeicons.css";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.css";
import "primeflex/primeflex.css";
import React, { useState } from "react";
import { Card, Col, Container, Nav, Navbar, Row } from "react-bootstrap";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { postPriceListConfig } from "../services/getPriceCode";
import { errorMessage, successMessage } from "../utils/alertMessage";
import { getUserData } from "../utils/localStorage";
import "jspdf-autotable";
import jsPDF from "jspdf";
import AdminMenu from "../pages/AdminMenu";

const MyPriceListTariff = () => {
  const navigate = useNavigate();

  const { state } = useLocation();

  const userData = getUserData();
  let brandId = userData.brandProfileData.id;
  const userRole = userData.userProfileRole;

  const priceListDTO = state.priceListDTO;

  // State for search query and filtered garments
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredGarments, setFilteredGarments] = useState(null);

  const [visible, setVisible] = useState(false);

  // Function to handle search input change
  const handleSearchInputChange = (event) => {
    setSearchQuery(event.target.value);
    filterGarments(event.target.value);
  };

  const allServices = Object.keys(priceListDTO).reduce((services, garment) => {
    Object.keys(priceListDTO[garment]).forEach((category) => {
      Object.keys(priceListDTO[garment][category]).forEach((service) => {
        if (!services.includes(service)) {
          services.push(service);
        }
      });
    });
    return services;
  }, []);

  const uniqueServices = Array.from(new Set(allServices));

  const [formData, setFormData] = useState({});
  const [submitted, setSubmitted] = useState(false);
  const [submitButtonPressed, setSubmitButtonPressed] = useState(false);

  const handleInputChange = (event, garmentName, categoryName, serviceName) => {
    const value = event.target.value;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [`${garmentName}-${categoryName}-${serviceName}`]: value,
    }));
  };

  // Function to filter garments based on search query
  const filterGarments = (query) => {
    const filtered = Object.keys(priceListDTO).filter((garment) =>
      garment.toLowerCase().includes(query.toLowerCase())
    );
    setFilteredGarments(filtered);
  };

  const garments =
    filteredGarments?.sort() || Object.keys(priceListDTO)?.sort();


  const renderGarments = () => {
    let serialNo = 1;
    return garments.map((garment, indexTop) => {
      let garmentPrinted = false;

      return Object.keys(priceListDTO[garment]).map((category, index) => {
        const hasValidPrice = uniqueServices.some((service) => {
          const priceData = priceListDTO[garment] &&
            priceListDTO[garment][category] &&
            priceListDTO[garment][category][service];

          return (
            priceData &&
            priceData.amount !== undefined &&
            priceData.amount !== 0
          )

        });
        if (!hasValidPrice) return null;

        const garmentCell = !garmentPrinted ? (
          <td>
            {garment}
          </td>
        ) : (
          <td></td>
        );

        const indexCell = !garmentPrinted ? (
          <td>{serialNo++}</td>
        ) : (
          <td></td>
        );

        garmentPrinted = true;

        return (
          <tr key={`${garment}-${category}`}>
            {indexCell}
            {garmentCell}
            <td>{category}</td>
            {uniqueServices.map((service) => {
              const priceData =
                priceListDTO[garment] &&
                priceListDTO[garment][category] &&
                priceListDTO[garment][category][service];

              // if (priceData && priceData.amount !== undefined && priceData.amount !== 0) {
              if (priceData && priceData.amount !== undefined) {
                const amount = priceData.amount;

                return (
                  <td key={`${garment}-${category}-${service}`}>
                    <InputText
                      type="number"
                      style={{ width: 50, height: 10 }}
                      id={`${garment}-${category}-${service}`}
                      name={`${garment}-${category}-${service}`}
                      onWheel={(e) => e.target.blur()}
                      value={
                        formData[`${garment}-${category}-${service}`] !==
                          undefined
                          ? formData[`${garment}-${category}-${service}`]
                          : amount
                      }
                      onChange={(e) =>
                        handleInputChange(e, garment, category, service)
                      }
                      required
                      onKeyDown={(e) => {
                        if (e.key === "ArrowUp" || e.key === "ArrowDown") {
                          e.preventDefault();
                        }
                      }}
                    />
                  </td>
                );
              } else {
                return <td key={`${garment}-${category}-${service}`}></td>;
              }
            })}
          </tr>
        )
      })
    });
  };


  const downloadPDF = (data, uniqueServices, type) => {
    const doc = new jsPDF("landscape");
    doc.setFontSize(20);
    doc.text("Tariff - " + state.selectedPriceCode, 120, 25);

    const tableData = data
      .map((garment) => {
        return Object.keys(priceListDTO[garment])
          .map((category, index) => {
            const row = [garment, category];
            let includeRow = false;
            uniqueServices.forEach((service) => {
              const priceData = priceListDTO[garment][category][service];
              if (
                priceData &&
                priceData.amount !== undefined &&
                priceData.amount !== 0
              ) {
                const amount = priceData.amount;
                includeRow = true;
                row.push(
                  formData[`${garment}-${category}-${service}`] !== undefined
                    ? formData[`${garment}-${category}-${service}`]
                    : amount
                );
              } else {
                row.push("");
              }
            });
            return includeRow ? row : null;
            // return row;
          })
          .filter((row) => row !== null);
      })
      .flat();

    const tableHeaders = ["Garment Name", "Category", ...uniqueServices];

    doc.autoTable({
      head: [tableHeaders],
      body: tableData,
      startY: 30,
      theme: "grid",
      styles: {
        fontSize: 10,
      },
    });
    if (type === "print") {
      // Create blob URL
      const blob = doc.output("blob");
      const blobURL = URL.createObjectURL(blob);

      // Open blob URL in a new window
      const printWindow = window.open(blobURL);
      if (printWindow) {
        printWindow.onload = () => {
          printWindow.print();
        };
      }
    } else {
      doc.save("Tariff-" + state.selectedPriceCode + ".pdf");
    }
  };


  const filterData = (data, uniqueServices, searchTerm) => {
    if (!searchTerm) {
      // Return full table data without search filtering
      return data
        .map((garment) => {
          return Object.keys(priceListDTO[garment])
            .map((category) => {
              const row = [garment, category];
              let includeRow = false;

              uniqueServices.forEach((service) => {
                const priceData = priceListDTO[garment][category][service];
                if (
                  priceData &&
                  priceData.amount !== undefined &&
                  priceData.amount !== 0
                ) {
                  includeRow = true;
                  const value =
                    formData[`${garment}-${category}-${service}`] !== undefined
                      ? formData[`${garment}-${category}-${service}`]
                      : priceData.amount;
                  row.push(value);
                } else {
                  row.push("");
                }
              });

              return includeRow ? row : null;
            })
            .filter((row) => row !== null);
        })
        .flat();
    }

    const searchLower = searchTerm.toLowerCase();

    // Return only rows that match the search term
    return data
      .map((garment) => {
        return Object.keys(priceListDTO[garment])
          .map((category) => {
            const row = [garment, category];
            let includeRow = false;

            uniqueServices.forEach((service) => {
              const priceData = priceListDTO[garment][category][service];
              if (
                priceData &&
                priceData.amount !== undefined &&
                priceData.amount !== 0
              ) {
                const value =
                  formData[`${garment}-${category}-${service}`] !== undefined
                    ? formData[`${garment}-${category}-${service}`]
                    : priceData.amount;
                row.push(value);

                // Check if search term is found in any relevant field
                if (
                  garment.toLowerCase().includes(searchLower) ||
                  category.toLowerCase().includes(searchLower) ||
                  service.toLowerCase().includes(searchLower) ||
                  value.toString().toLowerCase().includes(searchLower)
                ) {
                  includeRow = true;
                }
              } else {
                row.push("");
              }
            });

            return includeRow ? row : null;
          })
          .filter((row) => row !== null);
      })
      .flat();
  };

  const filteredOrderInfoData = filterData(
    filteredGarments?.sort() || Object.keys(priceListDTO)?.sort(),
    uniqueServices,
    searchQuery
  );
  const exportExcel = () => {
    import("xlsx").then((xlsx) => {
      const headerRow = ["Garment Name", "Category", ...uniqueServices];
      const dataRows = filteredOrderInfoData; // This is your current array-of-arrays

      const worksheet = xlsx.utils.aoa_to_sheet([headerRow, ...dataRows]);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };

      const excelBuffer = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });

      saveAsExcelFile(excelBuffer, "TariffList-" + state.selectedPriceCode);
    });
  };

  const saveAsExcelFile = (buffer, fileName) => {
    import("file-saver").then((module) => {
      if (module && module.default) {
        let EXCEL_TYPE =
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
        let EXCEL_EXTENSION = ".xlsx";
        const data = new Blob([buffer], {
          type: EXCEL_TYPE,
        });

        module.default.saveAs(
          data,
          fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION
        );
      }
    });
  };

  const handleSubmit = () => {
    setSubmitButtonPressed(true);
    const submittedData = [];

    Object.keys(priceListDTO).forEach((garment) => {
      Object.keys(priceListDTO[garment]).forEach((category) => {
        Object.keys(priceListDTO[garment][category]).forEach((service) => {
          const serviceData = priceListDTO[garment][category][service];
          const inputValue = formData[`${garment}-${category}-${service}`];
          const originalAmount = serviceData.amount;
          const amount = inputValue !== undefined ? inputValue : originalAmount;

          if (
            inputValue !== undefined &&
            amount !== "" &&
            inputValue !== originalAmount
          ) {
            submittedData.push({
              id: serviceData.id,
              garmentName: serviceData.garmentName,
              category: serviceData.category,
              brandAppServiceName: service,
              garmentCategory: serviceData.garmentCategory,
              brandAppService: serviceData.brandAppService,
              serviceUnit: serviceData.serviceUnit,
              amount: amount,
              minAmount: serviceData.minAmount,
              status: amount > 0,
            });
          }
        });
      });
    });

    let Data = {
      priceListDTO: submittedData,
      serviceUnit: state.serviceUnit,
      appServiceList: state.appServiceList,
      priceId: state.priceId,
    };

    postPriceListConfig(brandId, Data)
      .then((response) => {
        if (!response.data.error) {
          if (response.data.success === false) {
            errorMessage(response.data.message);
            setSubmitButtonPressed(false);
          } else {
            successMessage(response.data.message);
            setSubmitButtonPressed(false);
            if (userRole === "BY_ADMIN" || userRole === "BY_SUB_ADMIN_USER") {

              navigate("/TariffManagement")
            } else {
              navigate("/StorePriceCode")
            }


          }
        }
      })
      .catch((err) => {
        errorMessage();
      });
    setSubmitted(true);
  };

  const handleAddMoreGarment = () => {
    navigate("/tariff-list", {
      state: {
        priceListDTO: priceListDTO,
        selectedPriceCode: state.selectedPriceCode,
        type: 'price',
        serviceUnit: state.serviceUnit,
        appServiceList: state.appServiceList,
        priceId: state.priceId,
      }
    })
  }

  return (
    <div className="flex-1">
      <div
        className="h-3rem surface-0 sticky z-2 top-0 flex justify-content-center align-items-center"
        style={{
          "--surface-0": "#1752AA",
        }}
      >
        <div className="flex-1 flex ml-3 mr-3">
          <div className="flex-1 flex ">
            <div className="ml-3 flex justify-content-center align-items-center">
              <div className="h-1rem w-1rem border-circle flex justify-content-center align-items-center">
                <i
                  className="pi pi-angle-left"
                  onClick={() => {
                    if (userRole === "BY_ADMIN" || userRole === "BY_SUB_ADMIN_USER") {
                      navigate("/tariff-list-selection")
                    } else {
                      navigate("/StorePriceCode")
                    }
                  }
                  }
                  style={{ fontSize: "27px", cursor: "pointer", color: "#fff" }}
                ></i>
              </div>
            </div>
            <div className="flex-1 ml-5">
              <p className="text-2xl text-white font-bold uppercase">Tariff Management - My Tariff List</p>
            </div>
          </div>



          <div
            className="flex justify-content-center align-items-center cursor-pointer"
            onClick={() => setVisible(true)}
          >
            <i
              className="pi pi-bars"
              style={{ fontSize: "27px", marginRight: 30, color: "#fff" }}
            ></i>
          </div>
        </div>
      </div>
      <Container fluid style={{ marginBottom: 60 }}>
        <div className="row mb-1">
          <div className="col-md-2">
            <div
              style={{
                // backgroundColor: "#1752AA",
                // color: "white",
                marginTop: 2,
              }}
            >
              <div
                style={{
                  textDecoration: "none",
                  // display: "flex",
                  // flex: 1,
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  // width: "280px",
                  // height: "280px",
                  backgroundColor: "#fff",
                  padding: 10,
                  borderRadius: 20,
                  cursor: "pointer",
                  boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)",
                  transition: "0.3s",
                  margin: 5,
                  // marginTop: 15,
                  // marginBottom: 15,
                }}
              >
                <div className="row">
                  <div className="col-md-12" style={{ display: "flex", justifyContent: "space-between" }}>
                    <div >
                      <img
                        style={{ width: "46px" }}
                        src="/Img/rupee_1.png"
                        alt="logo"
                      />
                    </div>
                    <div style={{ textAlign: "center",}}>
                      <h5>
                        {state.type === "price" ? "Price" : "Package"} List
                      </h5>
                      <p className="service-list display-contents">
                        {state.selectedPriceCode}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-8">
            <div
              style={{
                // backgroundColor: "#1752AA",
                // color: "white",
                marginTop: 2,
              }}
            >
              <div
                style={{
                  textDecoration: "none",
                  display: "flex",
                  // flex: 1,
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  // width: "280px",
                  // height: "280px",
                  backgroundColor: "#fff",
                  paddingTop: 10,
                  borderRadius: 20,
                  cursor: "pointer",
                  boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)",
                  transition: "0.3s",
                  margin: 5,
                  // marginTop: 15,
                  // marginBottom: 15,
                }}
              >
                <div className="row mb-3">
                  <div className="col-md-12" style={{ display: "flex", justifyContent: "space-between" }}>
                    <div >
                      <img
                        style={{ width: "46px" }}
                        src="/Img/services.png"
                        alt="logo"
                      />
                    </div>
                    <div style={{ textAlign: "center" }}>
                      <h5>App Services</h5>

                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <p className="service-list display-contents">
                          {state.appServiceList.join(", ")}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-2">
            <div
              style={{
                // backgroundColor: "#1752AA",
                // color: "white",
                marginTop: 2,
              }}
            >
              <div
                style={{
                  textDecoration: "none",
                  // display: "flex",
                  // flex: 1,
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  // width: "280px",
                  // height: "280px",
                  backgroundColor: "#fff",
                  padding: 10,
                  borderRadius: 20,
                  cursor: "pointer",
                  boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)",
                  transition: "0.3s",
                  margin: 5,
                  // marginTop: 15,
                  // marginBottom: 15,
                }}
              >
                <div className="row">
                  <div className="col-md-12" style={{ display: "flex", justifyContent: "space-between" }}>
                    <div >
                      <img
                        style={{ width: "46px", color: "#fff" }}
                        src="/Img/quantity.png"
                        alt="logo"
                      />
                    </div>
                    <div style={{ textAlign: "center" }}>
                      <h5>Service Unit</h5>
                      <p className="service-list display-contents">
                        {" "}
                        {state.serviceUnit === "Qty"
                          ? "PIECE"
                          : state.serviceUnit}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Row>
          <Col style={{ marginBottom: 10, marginLeft:10, marginRight:10 }}>
            <main id="main" className="main">
              <section className="section">
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <div style={{ marginBottom: 10, marginLeft: 10, marginRight: 10 }}>
                    <InputText
                      value={searchQuery}
                      onChange={handleSearchInputChange}
                      placeholder="Search Garment"
                    />
                  </div>
                  <div className="flex justify-content-center align-items-center">
                    <Button
                      label="Add More Garment"
                      onClick={handleAddMoreGarment}
                      style={{ position: "relative" }}
                      className="font-bold px-5 py-3 p-button-raised p-button-rounded white-space-nowrap"
                    />
                  </div>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      gap: 20,
                      marginTop: 10,
                    }}
                  >
                    <img
                      className="cursor-pointer"
                      onClick={exportExcel}
                      style={{ width: "30px", height: "30px" }}
                      src="/Img/xls.png"
                      alt="logo"
                    />
                    <i
                      onClick={() =>
                        downloadPDF(
                          filteredGarments?.sort() ||
                          Object.keys(priceListDTO)?.sort(),
                          uniqueServices,
                          "download"
                        )
                      }
                      className="pi pi-download"
                      style={{
                        fontSize: "2rem",
                        color: "#1e439b",
                        cursor: "pointer",
                      }}
                    ></i>
                    <i
                      onClick={() =>
                        downloadPDF(
                          filteredGarments?.sort() ||
                          Object.keys(priceListDTO)?.sort(),
                          uniqueServices,
                          "print"
                        )
                      }
                      className="pi pi-print"
                      style={{
                        fontSize: "2rem",
                        color: "#ff0101",
                        cursor: "pointer",
                      }}
                    ></i>
                  </div>
                </div>
                <div className="tableFixHead">
                  <table className="table table-striped ">
                    <thead>
                      <tr>
                        <th>S No.</th>
                        <th>Garment Name</th>
                        <th>Category</th>
                        {uniqueServices.map((service) => (
                          <th key={service}>{service}</th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>{renderGarments()}</tbody>
                  </table>
                </div>
                <div className="flex justify-content-center align-items-center mt-4">
                  <Button
                    label="Submit"
                    onClick={handleSubmit}
                    disabled={submitButtonPressed}
                    style={{ position: "relative" }}
                    className="font-bold px-5 py-3 p-button-raised p-button-rounded white-space-nowrap"
                  />
                </div>
              </section>
            </main>
          </Col>
        </Row>
        <div style={{ color: "red" }}>
          <h2>
            Note : Blank Fields are considered as 0 (zero) price. Services with
            0 (zero) price will not be displayed in price list{" "}
          </h2>
        </div>
      </Container>
      {/*<div
      style={{
        position: "fixed",
        bottom: 20,
        width: "100%",
        textAlign: "center",
      }}
      >
        <Button
          label="Submit"
          onClick={handleSubmit}
          disabled={submitButtonPressed}
          style={{ position: "relative" }}
          className="font-bold px-5 py-3 p-button-raised p-button-rounded white-space-nowrap"
        />
      </div>*/}
      <footer style={{ backgroundColor: "#FBFBFB" }}>
        <Container fluid>
          <Row>
            <Col>
              <Nav className="flex social-media-div" style={{ marginLeft: 30 }}>
                <Link
                  to="https://www.youtube.com/channel/UCKdUWjGim18SoHC2jLbFsiw"
                  target="_blank"
                >
                  <i
                    className="pi pi-youtube"
                    style={{
                      fontSize: "2rem",
                      color: "red",
                      cursor: "pointer",
                    }}
                  ></i>
                </Link>
                <Link
                  to="https://www.instagram.com/dhobicart/?hl=en"
                  target="_blank"
                >
                  <i
                    className="pi pi-instagram"
                    style={{
                      fontSize: "2rem",
                      color: "#d62976",
                      cursor: "pointer",
                    }}
                  ></i>
                </Link>
                <Link
                  to="https://www.linkedin.com/company/71974228/admin/dashboard/"
                  target="_blank"
                >
                  <i
                    className="pi pi-linkedin"
                    style={{
                      fontSize: "2rem",
                      color: "#0072b1",
                      cursor: "pointer",
                    }}
                  ></i>
                </Link>
                <Link
                  to="https://www.facebook.com/oneindiatechno"
                  target="_blank"
                >
                  <i
                    className="pi pi-facebook"
                    style={{
                      fontSize: "2rem",
                      color: "#1877F2",
                      cursor: "pointer",
                    }}
                  ></i>
                </Link>
                <Link
                  to="https://play.google.com/store/apps/details?id=com.dhobicartV2"
                  target="_blank"
                >
                  <i
                    className="pi pi-android"
                    style={{
                      fontSize: "2rem",
                      color: "#a4c639",
                      cursor: "pointer",
                    }}
                  ></i>
                </Link>
                <Link to="tel:+91 9319518337" target="_blank">
                  <i
                    className="pi pi-phone"
                    style={{
                      fontSize: "2rem",
                      color: "#1877F2",
                      cursor: "pointer",
                    }}
                  ></i>
                </Link>
              </Nav>
            </Col>
            {/*<Col>
              <Link
                to="https://www.oneindiatech.com/?page_id=75"
                target="_blank"
                style={{ textDecoration: "none", fontSize: 20 }}
              >
                Contact Us!
              </Link>
              <p>Phone : +91 9319518337</p>
            </Col>*/}
          </Row>
          <Row>
            <Col>
              <div className="text-center p-3" style={{ fontSize: 16 }}>
                &copy; {new Date().getFullYear()} Copyright:{" "}
                <a className="text-dark" href="https://oneindiatech.com/">
                  One India Technologies Pvt. Ltd.
                </a>
              </div>
            </Col>
          </Row>
        </Container>
      </footer>
      <AdminMenu setVisible={setVisible} visible={visible} />
    </div>
  );
};

export default MyPriceListTariff;
